export default ["Contract", "Permanent", "Temporary", "Internship"];
